import React from 'react';
import { Grid } from '@mui/material';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';

interface Props {
  data: {
    value: number;
    name: string;
    percentage: number;
    color: string;
    progress: string;
  }[];
}

const PieChartLegend: React.FC<Props> = ({ data: values }) => {
  return (
    <div className="pie-chart-legend">
      <Grid container rowSpacing={0.75}>
        {values.map((el) => (
          <React.Fragment key={`${el.name}-${el.percentage}-${el.value}`}>
            <Grid item xs={5}>
              <div className="legend-title-container">
                <span
                  className="legend-dot"
                  style={{
                    backgroundColor: el.color,
                  }}
                />
                <span className="legend-title">{el.name}</span>
              </div>
            </Grid>
            <Grid item xs={4}>
              <span className="percentage-container">
                {el.progress == 'up' ? (
                  <span>
                    <ArrowUpwardRoundedIcon
                      className="progress-up"
                      fontSize="small"
                    />
                  </span>
                ) : (
                  <span>
                    <ArrowDownwardRoundedIcon
                      className="progress-down"
                      fontSize="small"
                    />
                  </span>
                )}
                <span className="percentag-container">{el.percentage}%</span>
              </span>
            </Grid>
            <Grid item xs={3}>
              <span className="value-container">{el.value}</span>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </div>
  );
};

export default PieChartLegend;
